<button
  #trigger
  type="button"
  class="hopper-trigger"
  data-test="current-business"
  [class.is-phone]="mobile"
  aria-haspopup="listbox"
  [attr.aria-expanded]="open"
  (click)="toggle()"
>
  <span class="hopper-mark" aria-hidden="true">
    <svg viewBox="0 0 44 44" focusable="false">
      @for (facet of facets; track facet) {
      <polygon [attr.points]="facet.points" [attr.fill]="facet.fill"></polygon>
      }
    </svg>
  </span>
  @if (companyName) {
  <span class="hopper-trigger__name" [title]="companyName">{{
    companyName
  }}</span>
  }
  <svg
    class="hopper-trigger__chevron"
    data-test="hopper-chevron"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
</button>

@if (open && mobile) {
<div
  class="hopper-backdrop"
  data-test="hopper-backdrop"
  aria-hidden="true"
  (click)="close()"
></div>
} @if (open) {
<div
  class="hopper-panel"
  data-test="hopper-panel"
  [class.is-sheet]="mobile"
  [class.is-hopping]="hopping !== null"
  (keydown)="onPanelKey($event)"
>
  <span
    class="hopper-panel__edge"
    [style.background]="edge"
    aria-hidden="true"
  ></span>
  <label class="hopper-search">
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4 4" />
    </svg>
    <input
      #search
      type="text"
      data-test="hopper-search"
      role="combobox"
      autocomplete="off"
      spellcheck="false"
      aria-autocomplete="list"
      aria-expanded="true"
      aria-controls="hopper-list"
      [attr.aria-label]="'PROFILES.HOP.SEARCH' | translate"
      [attr.aria-activedescendant]="
        active !== null ? 'hopper-row-' + active : null
      "
      [placeholder]="'PROFILES.HOP.SEARCH' | translate"
      [value]="query"
      (input)="filter($any($event.target).value)"
      (keydown)="onSearchKey($event)"
    />
  </label>
  @if (note) {
  <p class="hopper-note" role="status">
    {{ note.key | translate : note.params }}
  </p>
  }
  <ul id="hopper-list" class="hopper-list" role="listbox">
    @for (row of rows; track byId($index, row)) {
    <li
      role="option"
      data-test="hopper-row"
      class="hopper-row"
      [id]="'hopper-row-' + row.tenantId"
      [class.is-current]="row.current"
      [class.is-active]="row.tenantId === active"
      [class.is-busy]="row.tenantId === hopping"
      [attr.aria-disabled]="row.current ? 'true' : null"
      [attr.aria-selected]="row.tenantId === active"
      (click)="hop(row)"
      (mousemove)="!row.current && hopping === null && (active = row.tenantId)"
    >
      <span class="hopper-mark hopper-mark--row" aria-hidden="true">
        <svg viewBox="0 0 44 44" focusable="false">
          @for (facet of row.facets; track facet) {
          <polygon
            [attr.points]="facet.points"
            [attr.fill]="facet.fill"
          ></polygon>
          }
        </svg>
      </span>
      <span class="hopper-row__text">
        <span class="hopper-row__name">{{ row.name }}</span>
        @if (row.tenantId === hopping) {
        <span class="hopper-row__kind is-busy">{{
          "PROFILES.OPENING" | translate
        }}</span>
        } @else { @if (row.type) {
        <span class="hopper-row__kind">{{ row.type | translate }}</span>
        } }
      </span>
      @if (row.current) {
      <svg
        class="hopper-row__tick"
        data-test="hopper-tick"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M5 12.5l4.5 4.5L19 7.5" />
      </svg>
      } @if (row.tenantId === hopping) {
      <span class="hopper-row__spinner" aria-hidden="true"></span>
      }
    </li>
    }
  </ul>
  @if (loading) {
  <p class="hopper-quiet" data-test="hopper-loading">
    {{ "PROFILES.LOADING" | translate }}
  </p>
  } @if (loadFailed) {
  <p class="hopper-note hopper-note--error" role="alert">
    {{ "PROFILES.HOP.LOAD_FAILED" | translate }}
  </p>
  } @if (!loading && !loadFailed && !rows.length) {
  <p class="hopper-quiet" data-test="hopper-empty">
    {{ "PROFILES.HOP.NO_MATCH" | translate }}
  </p>
  }
  <div class="hopper-footer">
    <button
      type="button"
      class="hopper-footer__portal"
      data-test="hopper-portal"
      (click)="openPortal()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
        <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
        <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
        <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
      </svg>
      <span>{{ "USER_DROPDOWN.SWITCH_PROFILE" | translate }}</span>
    </button>
    @if (!mobile) {
    <kbd class="hopper-footer__key" aria-hidden="true">Esc</kbd>
    }
  </div>
</div>
}
